export default "__VITE_ASSET__DU_CQAd0__"